import { useEffect } from 'react'
import { FieldValues, UseFormSetValue } from 'libs/form'
import { Rate } from 'types/store'

type UsePopulateCommissionsProps = {
	data: Rate[] | undefined
	setData: UseFormSetValue<FieldValues>
}

export const usePopulateCommissions = ({ data, setData }: UsePopulateCommissionsProps) => {
	useEffect(() => {
		setData('commissions', data)
	}, [data])
}
